import { Voni } from '../client';

export class WebhookResource {
  constructor(private client: Voni) {}
  async list(): Promise<unknown[]> {
    return this.client.request('GET', '/integrations/webhooks/');
  }
  async create(url: string, description: string = ''): Promise<unknown> {
    const data = { url, description };
    return this.client.request('POST', '/integrations/webhooks/', undefined, data);
  }

  async delete(webhookId: number): Promise<boolean> {
    await this.client.request('DELETE', `/integrations/webhooks/${webhookId}`);
    return true;
  }
}
